// extracted by mini-css-extract-plugin
export var label = "_hf-2";
export var slideContainer = "_hf-0";
export var slider = "_hf-1";